// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h3 id="july-26th-2021">July 26th, 2021</h3>
      <p>Decision Reviews API version 2 Release Notes</p>
      <p>Version 2 of the Decision Reviews API is now released with the following changes:</p>
      <p>We've added a new key, <code>informalConferenceContact</code> (required when an informal conference is requested), which will allow us to support both Veteran and representative contacts for informal conferences.<br />
      We've updated the possible responses enum of <code>informalConferenceTime</code> to reflect the above  changes.<br />
      <code>socOptIn</code> is now required.<br />
      For the representative name, we've split <code>name</code> into <code>firstName</code> and <code>lastName</code> to be more flexible and allow more accurate entries.<br />
      The Veteran email field <code>emailAddressText</code> has been changed to <code>email</code>.</p>
      <p>Added hlrCreateAddress to now accept an address for this API. This change follows NOD format:<br />
      -<code>addressLine1</code><br />
      -<code>addressLine2</code><br />
      -<code>addressLine3</code><br />
      -<code>city</code><br />
      -<code>stateCode</code> - enum of all 2-character state codes (see the documentation for more info)<br />
      -<code>countryCodeISO2</code><br />
      -<code>zipCode5</code></p>
      <hr />
      <h3 id="june-6-2020">June 6, 2020</h3>
      <p>Initial release of the Decision Review API</p>
    </div>
  );
};

export default MarkdownComponent;
